module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    class: {
      'list': _vm.list
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "order-status text-xs-center",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "new"
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('v-container', {
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "pl-3": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('strong', {
    staticClass: "fs-18"
  }, [_vm._v("\n            Pedido n° " + _vm._s(_vm.value.register) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right mt-2"
  }, [_vm._v("\n          " + _vm._s(_vm.date) + "\n        ")])], 1), _vm._v(" "), (_vm.value.condominium !== null) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "order-color"
  }, [_vm._v("\n          " + _vm._s(_vm.value.condominium.name)), _c('br'), _vm._v("\n          Cliente: " + _vm._s(_vm.value.client)), _c('br'), _vm._v("\n          Unidade: " + _vm._s(_vm.value.unit)), _c('br')])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "mb-2": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "order-color"
  }, [_c('strong', [_vm._v("Itens Pedidos")]), _c('br'), _vm._v(" "), _vm._l((_vm.value.itens), function(item) {
    return [_c('span', {
      key: item.id
    }, [_vm._v("\n              " + _vm._s(item.name) + ";\n            ")])]
  })], 2)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "mb-5": ""
    }
  }, [_c('v-flex', [_c('div', {
    staticClass: "fs-18 mt-1"
  }, [_c('strong', [_vm._v("Valor total")]), _vm._v(": " + _vm._s(_vm._f("currency")(_vm.price)) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    staticClass: "elevation-0 order-details-btn ma-0",
    on: {
      "click": function($event) {
        return _vm.orderDetails(_vm.value.id)
      }
    }
  }, [_vm._v("+ detalhes")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f6c2b7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/sharedComponents/order/index.vue
// module id = 506
// module chunks = 0 3